import HomePageHeader from './utils/HomePageHeader.jsx';
import ProductFeaturesComponent from './utils/ProductFeaturesComponent.jsx';
import PricingPage from '../PricingPage/PricingPage.jsx';
import HowItWorks from './utils/HowItWorks.jsx';
import AboutUs from './utils/AboutUs.jsx';
import SuccessStories from './utils/SuccessStories.jsx';
import FAQSection from './utils/FAQSection.jsx';

function HomePage() {
  return (
    <div className="home">
      <HomePageHeader />
      <ProductFeaturesComponent />
      <HowItWorks />
      <AboutUs />
      <PricingPage />
      <SuccessStories />
      <FAQSection />
    </div>
  );
}

export default HomePage;